import { render, staticRenderFns } from "./marketing-info.vue?vue&type=template&id=1f756eb6&scoped=true"
import script from "./marketing-info.vue?vue&type=script&lang=js"
export * from "./marketing-info.vue?vue&type=script&lang=js"
import style0 from "./marketing-info.vue?vue&type=style&index=0&id=1f756eb6&prod&lang=scss&scoped=true"
import style1 from "./marketing-info.vue?vue&type=style&index=1&id=1f756eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f756eb6",
  null
  
)

export default component.exports